import { render, staticRenderFns } from "./adminIndex.vue?vue&type=template&id=3a5f184c"
import script from "./adminIndex.vue?vue&type=script&lang=js"
export * from "./adminIndex.vue?vue&type=script&lang=js"
import style0 from "./adminIndex.vue?vue&type=style&index=0&id=3a5f184c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports